<template>
  <SimpleDataCard
      :title="'Toplam B2B Müşteri Sayısı'"
      :data="reportCompanyData.totalB2bCustomer.toString()"
      :description="'Tüm Zamanlar'"
      :loading="reportCompanyDataLoading"
  >

  </SimpleDataCard>
</template>

<script>

import SimpleDataCard from "@/components/dashboard/SimpleDataCard";
import {numberConverter} from "../../../../helpers";
import {mapState} from "vuex";

export default {
  name: "ToplamB2BMusteriSayisi",
  components:{
    SimpleDataCard
  },
  computed: {
    ...mapState("dashboard",["reportCompanyData","reportCompanyDataLoading"])
  },
  methods:{
    numberConverter
  }
}
</script>

<style scoped>

</style>